import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import { TestComponent } from './test.component';
import { ModalDirective } from './modal.directive';

@NgModule({
  declarations: [ModalComponent, TestComponent, ModalDirective],
  imports: [CommonModule],
  exports: [TestComponent],
})
export class ModalModule {}
